export default {
  "component.portalVersion.tip": "切換後會保留當前頁面並刷新選單",
  "component.portalVersion.classic": "經典版",
  "component.portalVersion.v2": "新版",
  "component.tagSelect.expand": "展開",
  "component.tagSelect.collapse": "收起",
  "component.tagSelect.all": "全部",
};
